export default __webpack_public_path__ + "static/media/consulting.a9196038.jpg";